module.exports = __webpack_public_path__ + "static/media/ehfsp.009681a6.png";